export default __webpack_public_path__ + "static/media/reddit.eae68189.svg";